module.exports = __webpack_public_path__ + "25bcbb2c44380fc3b9afe3c61b5534eb.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/forum.png
 ** module id = 1548
 ** module chunks = 0
 **/